import instance from '../../api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDoneResponse, ILinkApplications } from './interfaces';

export const getApplications = (data: IDynamicTableParams) => {
  return instance()
    .post('/application/list', data)
    .then((response) => response.data);
};

export const getApplicationsCount = (data: IDynamicTableParams) => {
  return instance()
    .post('/application/listCount', data)
    .then((response) => response.data);
};

export const getApplicationAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/application/availableColumns', {})
    .then((response) => response.data);
};

export const getApplicationAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/application/availableGroupColumns', {})
    .then((response) => response.data);
};

export const reassignExecutorApps = (values: any) => {
  return instance()
    .post('/reassignment/reassignSelectedApplications', values)
    .then((response) => response.data);
};

export const linkApplications = (linkApplications: ILinkApplications) => {
  return instance()
    .post('/application/doneApplications', linkApplications)
    .then((response) => response.data);
};

export const getDoneResponses = () => {
  return instance()
    .post<IDoneResponse[]>('/dictionary/doneResponse')
    .then((response) => response.data);
};
